let state = {
  sessionId: localStorage.getItem("Authorization"),
  user: JSON.parse(localStorage.getItem("User"))
}
export default state



// WEBPACK FOOTER //
// ./src/store/login/state.js